import { z } from 'zod';
import { configFromEnv } from '@utils/config';
import { shareComponentEntry } from '../../api/request.share-component-entry.js';

const shareEntryPath = configFromEnv.asString("SHARE_ENTRY_PATH", {
  schema: z.string().optional()
});
async function shareComponentEntryRequest(user, entry, message) {
  if (!user) {
    return entry;
  }
  return (await shareEntryPath.get()) ? await shareThroughNextApi(entry, message) : await shareComponentEntry(user, entry, message);
}

// specific integration to use for saving the component entry using a Next.js
// api integration from this package
async function shareThroughNextApi(entry, message) {
  if (!entry.envelope.objectID) {
    throw new Error("shareComponentEntry(): Cannot share entries without an associated envelope");
  }
  const res = await fetch((await shareEntryPath.get()) ?? "", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      entry,
      message
    }),
    credentials: "include"
  });
  if (!res.ok) {
    throw new Error("shareComponentEntry.saveThroughNextApi(): Failed to save component");
  }
  return entry;
}

export { shareComponentEntryRequest };
//# sourceMappingURL=request.share.js.map
